import { lazyWithRetry } from 'src/utils/lazyWithRetry';

// Lazy load: Event pages (heavy with charts/tables)
export const LazyInventoryEvent = lazyWithRetry(() =>
  import('src/navigations/Routes/InventoryEvent').then((m) => ({
    default: m.InventoryEvent,
  }))
);
export const LazyInventoryEventPageRedirect = lazyWithRetry(() =>
  import('src/navigations/Routes/InventoryEvent/InventoryEventPageRedirect').then(
    (m) => ({ default: m.InventoryEventPageRedirect })
  )
);
export const LazySales = lazyWithRetry(() =>
  import('src/navigations/Routes/Sales').then((m) => ({
    default: m.Sales,
  }))
);
export const LazySalesEvent = lazyWithRetry(() =>
  import('src/navigations/Routes/SalesEvent/SalesEvent').then((m) => ({
    default: m.SalesEvent,
  }))
);
export const LazyPurchases = lazyWithRetry(() =>
  import('src/navigations/Routes/Purchases').then((m) => ({
    default: m.Purchases,
  }))
);
export const LazyPurchaseEvent = lazyWithRetry(() =>
  import('src/navigations/Routes/PurchaseEvent/PurchaseEvent').then((m) => ({
    default: m.PurchaseEvent,
  }))
);
export const LazyOnSaleEvent = lazyWithRetry(() =>
  import('src/navigations/Routes/OnSaleEvent/OnSaleEvent').then((m) => ({
    default: m.OnSaleEvent,
  }))
);
export const LazyOnSaleDiscovery = lazyWithRetry(() =>
  import('src/navigations/Routes/OnSaleDiscovery').then((m) => ({
    default: m.OnSaleDiscovery,
  }))
);

// Lazy load: Search pages
export const LazyInventorySearch = lazyWithRetry(() =>
  import('src/navigations/Routes/InventorySearch').then((m) => ({
    default: m.InventorySearch,
  }))
);
export const LazyInventorySearchV2 = lazyWithRetry(() =>
  import('src/navigations/Routes/InventorySearchV2').then((m) => ({
    default: m.InventorySearchV2,
  }))
);
export const LazySaleSearch = lazyWithRetry(() =>
  import('src/navigations/Routes/SaleSearch').then((m) => ({
    default: m.SaleSearch,
  }))
);
export const LazySaleSearchV2 = lazyWithRetry(() =>
  import('src/navigations/Routes/SaleSearchV2').then((m) => ({
    default: m.SaleSearchV2,
  }))
);
export const LazyPurchaseSearch = lazyWithRetry(() =>
  import('src/navigations/Routes/PurchaseSearch/PurchaseSearch').then((m) => ({
    default: m.PurchaseSearch,
  }))
);
export const LazyPurchaseSearchV2 = lazyWithRetry(() =>
  import('src/navigations/Routes/PurchaseSearchV2').then((m) => ({
    default: m.PurchaseSearchV2,
  }))
);

export const LazyRetail = lazyWithRetry(() =>
  import('src/navigations/Routes/Retail').then((m) => ({
    default: m.Retail,
  }))
);

// Lazy load: Reports (very heavy with tables/charts)
export const LazyReports = lazyWithRetry(() =>
  import('src/navigations/Routes/Reports').then((m) => ({
    default: m.Reports,
  }))
);
export const LazyReportsV2 = lazyWithRetry(() =>
  import('src/navigations/Routes/Reports').then((m) => ({
    default: m.ReportsV2,
  }))
);
export const LazyReportsInventory = lazyWithRetry(() =>
  import('src/navigations/Routes/ReportsInventory').then((m) => ({
    default: m.ReportsInventory,
  }))
);
export const LazyReportsInventoryV2 = lazyWithRetry(() =>
  import('src/navigations/Routes/ReportsInventory/ReportsInventoryV2').then(
    (m) => ({
      default: m.ReportsInventoryV2,
    })
  )
);
export const LazyReportsSale = lazyWithRetry(() =>
  import('src/navigations/Routes/ReportsSale').then((m) => ({
    default: m.ReportsSale,
  }))
);
export const LazyReportsSaleV2 = lazyWithRetry(() =>
  import('src/navigations/Routes/ReportsSale/ReportsSaleV2').then((m) => ({
    default: m.ReportsSaleV2,
  }))
);
export const LazyReportsPurchase = lazyWithRetry(() =>
  import('src/navigations/Routes/ReportsPurchase').then((m) => ({
    default: m.ReportsPurchase,
  }))
);
export const LazyReportsCommission = lazyWithRetry(() =>
  import('src/navigations/Routes/ReportsCommission').then((m) => ({
    default: m.ReportsCommission,
  }))
);
export const LazyReportsSaleLineItem = lazyWithRetry(() =>
  import('src/navigations/Routes/ReportsSaleLineItem').then((m) => ({
    default: m.ReportsSaleLineItem,
  }))
);
export const LazyReportsSoldTicket = lazyWithRetry(() =>
  import('src/navigations/Routes/ReportsSoldTicket').then((m) => ({
    default: m.ReportsSoldTicket,
  }))
);
export const LazyReportsPurchaseOrderLineItem = lazyWithRetry(() =>
  import('src/navigations/Routes/ReportsPurchaseOrderLineItem').then((m) => ({
    default: m.ReportsPurchaseOrderLineItem,
  }))
);
export const LazyReportsCostOfGoodsSold = lazyWithRetry(() =>
  import('src/navigations/Routes/ReportsCostOfGoodsSold').then((m) => ({
    default: m.ReportsCostOfGoodsSold,
  }))
);
export const LazyReportsSaleCostAdjustments = lazyWithRetry(() =>
  import('src/navigations/Routes/ReportsSaleCostAdjustments').then((m) => ({
    default: m.ReportsSaleCostAdjustments,
  }))
);
export const LazyReportsTicketGroup = lazyWithRetry(() =>
  import('src/navigations/Routes/ReportsTicketGroup').then((m) => ({
    default: m.ReportsTicketGroup,
  }))
);
export const LazySyncCenter = lazyWithRetry(() =>
  import('src/navigations/Routes/Settings/Views/SyncCenter').then((m) => ({
    default: m.SyncCenter,
  }))
);

// Lazy load: Settings (large with many sub-views)
export const LazySettings = lazyWithRetry(() =>
  import('src/navigations/Routes/Settings').then((m) => ({
    default: m.Settings,
  }))
);
export const LazySettingsViews = {
  MyAccount: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.MyAccount,
    }))
  ),
  CurrencyConversion: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.CurrencyConversion,
    }))
  ),
  FulfillmentProviders: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.FulfillmentProviders,
    }))
  ),
  PurchaseOrderSetting: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.PurchaseOrderSetting,
    }))
  ),
  InventorySetting: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.InventorySetting,
    }))
  ),
  AccountingSetting: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.AccountingSetting,
    }))
  ),
  UsersManagement: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.UsersManagement,
    }))
  ),
  Users: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.Users,
    }))
  ),
  Roles: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.Roles,
    }))
  ),
  Teams: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.Teams,
    }))
  ),
  VendorManagement: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.VendorManagement,
    }))
  ),
  Payments: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.Payments,
    }))
  ),
  Vendors: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.Vendors,
    }))
  ),
  SyncCenter: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.SyncCenter,
    }))
  ),
  SellerAccount: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.SellerAccount,
    }))
  ),
  AccountAutoPricingSettings: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.AccountAutoPricingSettings,
    }))
  ),
  DialogSuppression: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.DialogSuppression,
    }))
  ),
  EventDiscovery: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.EventDiscovery,
    }))
  ),
  CustomTabsSettingsView: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.CustomTabsSettingsView,
    }))
  ),
  TaxRates: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.TaxRates,
    }))
  ),
  BoostRules: lazyWithRetry(() =>
    import('src/navigations/Routes/Settings').then((m) => ({
      default: m.SettingsViews.BoostRules,
    }))
  ),
};

export const LazyCustomTabEmbedView = lazyWithRetry(() =>
  import('src/components/CustomTabs/CustomTabEmbedView').then((m) => ({
    default: m.CustomTabEmbedView,
  }))
);

// Lazy load: Other heavy/infrequent routes
export const LazyEmail = lazyWithRetry(() =>
  import('src/navigations/Routes/Email').then((m) => ({ default: m.Email }))
);
export const LazySponsoredListings = lazyWithRetry(() =>
  import('src/navigations/Routes/SponsoredListings').then((m) => ({
    default: m.SponsoredListings,
  }))
);
export const LazyPayments = lazyWithRetry(() =>
  import('src/navigations/Routes/Payments').then((m) => ({
    default: m.Payments,
  }))
);
export const LazyAccounting = lazyWithRetry(() =>
  import('src/navigations/Routes/Accounting').then((m) => ({
    default: m.Accounting,
  }))
);
export const LazyActivity = lazyWithRetry(() =>
  import('src/navigations/Routes/Activity').then((m) => ({
    default: m.Activity,
  }))
);
export const LazyReleaseNotes = lazyWithRetry(() =>
  import('src/navigations/Routes/ReleaseNotes').then((m) => ({
    default: m.ReleaseNotes,
  }))
);
export const LazyHelpCenter = lazyWithRetry(() =>
  import('src/navigations/Routes/HelpCenter').then((m) => ({
    default: m.HelpCenter,
  }))
);
export const LazyRedirectToStubHubUk = lazyWithRetry(() =>
  import('src/navigations/Routes/RedirectToStubHubUk').then((m) => ({
    default: m.RedirectToStubHubUk,
  }))
);
export const LazyReachProSupportCase = lazyWithRetry(() =>
  import('src/navigations/Routes/ReachProSupportCase').then((m) => ({
    default: m.ReachProSupportCase,
  }))
);
export const LazyTicketUtilsLanding = lazyWithRetry(() =>
  import('src/navigations/Routes/TicketUtilsLanding').then((m) => ({
    default: m.TicketUtilsLanding,
  }))
);
export const LazyBoostCredit = lazyWithRetry(() =>
  import('src/navigations/Routes/BoostCredit').then((m) => ({
    default: m.BoostCredit,
  }))
);

export const LazySeasonsPage = lazyWithRetry(() =>
  import('src/navigations/Routes/Seasons/SeasonsPage').then((m) => ({
    default: m.SeasonsPage,
  }))
);
